import React, { useEffect, useState } from "react";

import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import cloneDeep from "lodash/cloneDeep";
import {
  Dialog,
  Button,
  TextInput,
  RadioButton,
  DropdownWithSearch,
  Dropdown,
  Image,
} from "hesus-ui-kit";
import {
  useGetGeneralParameters,
  useGetMultiUserCurrenciesByCountryId,
} from "@hooks/useGeneralParams";
import { handleApiError } from "@utils/errorHandler";
import CenterList from "./components/CenterList";
import TransportTreatmentSeparated from "./components/TransportTreatmentSeparated";
import TransportTreatment from "./components/TransportTreatment";
import TransportOnly from "./components/TransportOnly";
import TreatmentOnly from "./components/TreatmentOnly";
import PollutionParameterMessage from "./components/PollutionParameterMessage";
import PollutionParameterTable from "./components/PollutionParameterTable";

import closeIcon from "@icons/ic-close-white.svg";
import { priceTypes, country } from "@utils/constants";
import {
  renderPriceWithCurrency,
  getValorisationRateOptions,
} from "@utils/utils";
import { Dropdown as DropdownProduct } from "./components/Dropdown/Dropdown";

import {
  HeaderWrapper,
  Title,
  SubCategoryName,
  FormBody,
  FiltersContainer,
  FiltersTitle,
  FiltersWrapper,
  FilterOption,
  FiltersBtnWrapper,
  FiltersLabel,
  OptionsWrapper,
  CentreProductsContainer,
  ButtonWrapper,
  FlexRow,
  APIErrorMEssage,
  LoadingContainer,
  CommentsContainer,
  EditOptionsLabel,
  EditOptionsDescription,
  EditOptionsPreDefinedDescription,
  SolutionEditLoader,
} from "./AddEditSolution.styled";

const AddEditSolution = (props) => {
  const {
    id,
    solution,
    title,
    t,
    onClose,
    onSolutionCreation,
    enquiryService,
    enquirySubCategoryName,
    enquirySubCategoryId,
    enquiryId,
    countryId,
  } = props;

  const [products, setProducts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [hauliers, setHauliers] = useState([]);
  const [centres, setCentres] = useState([]);
  const [centreLoading, setCentreLoading] = useState(false);
  const [centreProducts, setCentreProducts] = useState([]);
  const [centreProductsList, setCentreProductsList] = useState([]);
  const [transportTypes, setTransportTypes] = useState([]);
  const [pollutionParams, setPollutionParams] = useState([]);
  const [isPollutionParamsLoading, setPollutionParamsLoadingStatus] =
    useState(false);
  const [isPollutionParamsVisible, setPollutionParamsVisibility] =
    useState(false);
  const [isSolutionEditDataLoading, setSolutionEditDataLoad] = useState(false);

  const [centreProductMasterList, setCentreProductMasterList] = useState([]);

  const priceTypeText = {
    1: "CENTRE_PRODUCT_PRICE_TREATMENT",
    2: "CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT",
    3: "CENTRE_PRODUCT_PRICE_UNKNOWN",
    4: "CENTRE_PRODUCT_PRICE_TRANSPORT",
  };

  const [formData, setFormData] = useState({
    products: [],
    suppliers: [],
    centre: { required: true, value: "", error: "" },
    centreProduct: { required: true, value: "", error: "" },
    logisticFlow: "",
    haulier: { required: true, value: "", error: "" },
    priceType: { required: true, value: 1, error: "" },
    transportPriceType: { required: true, value: "", error: "" },
    transportType: { required: true, value: "", error: "" },
    selectedTransportPriceId: { required: true, value: "", error: "" },
    treatmentPrice: "",
    transportPrice: "",
    treatmentCurrency: { required: true, value: "", error: "" },
    transportCurrency: { required: true, value: "", error: "" },
    treatmentUnit: "",
    transportUnit: "",
    tgap: "",
    internalComment: "",
    quoteComment: "",
    pollutionComment: { required: true, value: "", error: "" },
    allocation: {
      required: false,
      value: solution?.allocation ? solution.allocation : 0,
      error: "",
    },
  });
  const [isProductLoading, setProductsLoadingStatus] = useState(false);
  const [isSuppliersLoading, setSuppliersLoadingStatus] = useState(false);
  const [isHauliersLoading, setHaulierLoadingStatus] = useState(false);
  const [isCentreProductsLoading, setCentreProductsLoadingStatus] =
    useState(false);
  const [isTransportTypesLoading, setTransportTypesLoadingStatus] =
    useState(false);
  const [isSolutionCreating, setDataSaveStatus] = useState(false);
  const [createSolutionAPIError, setCreateSolutionAPIError] = useState("");
  const [productsAPIError, setProductsAPIError] = useState("");
  const [suppliersAPIError, setSuppliersAPIError] = useState("");
  const [centreProductsAPIError, setCentreProductsAPIError] = useState("");
  const [hauliersAPIError, setHaulierAPIError] = useState("");
  const [transportTypesAPIError, setTransportTypesAPIError] = useState("");
  const [addTransportPriceSection, setTransportPriceSectionVisibility] =
    useState(false);
  const [unitList, setUnitList] = useState({});

  const generalParams = useGetGeneralParameters();

  const userCurrency = useGetMultiUserCurrenciesByCountryId(countryId);

  const unitObject = generalParams?.unitList;

  useEffect(() => {
    if (unitObject?.length > 0) {
      setUnitList([{ label: t("SELECT_UNIT"), value: "" }, ...unitObject]);
    }
  }, [unitObject]);

  const isSolutionEdit = !!id && !!solution;

  const TRANSPORT_ONLY = 9;
  const POLLUTED_SOILS = 1;

  const onProductSelect = (selectedProducts) => {
    setFormData({ ...formData, products: selectedProducts });
  };

  const onSupplierSelect = (selectedSuppliers) => {
    setFormData({ ...formData, suppliers: selectedSuppliers });
  };

  const onHaulierSelect = (selectedHaulier) => {
    setFormData({
      ...formData,
      priceType: { ...formData.priceType, value: priceTypes.TransportOnly },
      haulier: { ...formData.haulier, error: "", value: selectedHaulier },
    });
  };

  const onCentresSelect = (centre) => {
    const selectedCentre = centreProducts.find(
      (product) => product.id === centre.id
    );
    let centreProductItems = [];
    if (centreProductMasterList.hasOwnProperty(selectedCentre.id)) {
      setCentreProductsList(centreProductMasterList[selectedCentre.id]);
    } else {
      const productIds = formData.products.map((product) => product.value);

      let subCategories = [parseInt(enquirySubCategoryId, 10)];

      // for materials send all 3 subcategories related to materials
      if (
        parseInt(enquirySubCategoryId, 10) === 3 ||
        parseInt(enquirySubCategoryId, 10) === 4 ||
        parseInt(enquirySubCategoryId, 10) === 6
      ) {
        subCategories = [3, 4, 6];
      }
      setCentreProductsList([]);
      setCentreProductsLoadingStatus(true);
      let url = `/companies/${selectedCentre.companyId}/centres/${
        selectedCentre.id
      }/products?status=1&products=${JSON.stringify(
        productIds
      )}&subCategories=${JSON.stringify(
        subCategories
      )}&countries=[${countryId}]&limit=-1&orderBy=asc&orderColumn=companyName`;

      if (enquiryService === "EVACUATION") {
        url = `/companies/${selectedCentre.companyId}/centres/${
          selectedCentre.id
        }/products?status=1&products=${JSON.stringify(
          productIds
        )}&subCategories=${JSON.stringify(
          subCategories
        )}&removal=true&supply=false&countries=[${countryId}]&limit=-1&orderBy=asc&orderColumn=companyName`;
      } else if (enquiryService === "DELIVERY") {
        url = `/companies/${selectedCentre.companyId}/centres/${
          selectedCentre.id
        }/products?status=1&products=${JSON.stringify(
          productIds
        )}&subCategories=${JSON.stringify(
          subCategories
        )}&removal=false&supply=true&countries=[${countryId}]&limit=-1&orderBy=asc&orderColumn=companyName`;
      }

      axios
        .get(url)
        .then((response) => {
          response.data.centerProducts.map((productItem) => {
            productItem.prices?.map((price) => {
              let currencyText = renderPriceWithCurrency(
                price.price,
                t(price.unit),
                price.currency?.name,
                price.currency?.position
              );
              let priceLabel = price?.label ? `-${price.label}` : "";
              let displayLabel = `[${productItem.product.name}] ${
                productItem.label ? productItem.label : ""
              } ${priceLabel}`;
              let displaySubLabel = `${t(
                priceTypeText[price.priceType]
              )}: ${currencyText}`;
              centreProductItems = [
                {
                  id: productItem.id,
                  label: `[${productItem.product.name}]${t(
                    priceTypeText[price.priceType]
                  )}(${currencyText})`,
                  displayLabel,
                  displaySubLabel,
                  value: `${productItem.id} - ${price.id}`,
                  price,
                },
                ...centreProductItems,
              ];
            });
          });
          setCentreProductMasterList({
            ...centreProductMasterList,
            [selectedCentre.id]: centreProductItems,
          });
          setCentreProductsList(centreProductItems);
          setCentreProductsAPIError("");
          setCentreProductsLoadingStatus(false);
        })
        .catch((error) => {
          setCentreProductsLoadingStatus(false);
          // setCentreProductsAPIError(
          //   error.response.data?.errors[0]?.message ?? "API Error"

          // );
        });
    }
    setFormData({
      ...formData,
      centre: { ...formData.centre, error: "", value: centre },
      centreProduct: { required: true, value: "", error: "" },
    });
  };

  const onCentreProductSelect = (selectedCentreProduct) => {
    if (selectedCentreProduct.price.priceType === 2) {
      setFormData({
        ...formData,
        centreProduct: {
          required: true,
          value: parseInt(selectedCentreProduct.id, 10),
          error: "",
        },
        priceType: {
          ...formData.priceType,
          value: parseInt(selectedCentreProduct.price.priceType, 10),
        },
        treatmentPrice: selectedCentreProduct.price.price,
        treatmentCurrency: {
          required: true,
          value: parseInt(selectedCentreProduct.price.currency.id, 10),
          error: "",
        },
        treatmentUnit: selectedCentreProduct.price.unit,
        tgap: selectedCentreProduct.price.tax,
        transportPrice: selectedCentreProduct.price.price,
        transportCurrency: {
          required: true,
          value: parseInt(selectedCentreProduct.price.currency.id, 10),
          error: "",
        },
        transportUnit: selectedCentreProduct.price.unit,
        transportType: {
          ...formData.transportType,
          value:
            selectedCentreProduct.price.transportTypes?.length == 1
              ? parseInt(selectedCentreProduct.price.transportTypes[0].id, 10)
              : "",
        },
      });
    }
    if (selectedCentreProduct.price.priceType === 4) {
      setFormData({
        ...formData,
        centreProduct: {
          required: true,
          value: parseInt(selectedCentreProduct.id, 10),
          error: "",
        },
        priceType: {
          ...formData.priceType,
          value: 3,
        },
        tgap: selectedCentreProduct.price.tax,
        transportPrice: selectedCentreProduct.price.price,
        transportCurrency: {
          required: true,
          value: parseInt(selectedCentreProduct.price.currency.id, 10),
          error: "",
        },
        transportUnit: selectedCentreProduct.price.unit,
        transportType: {
          ...formData.transportType,
          value:
            selectedCentreProduct.price.transportTypes?.length == 1
              ? parseInt(selectedCentreProduct.price.transportTypes[0].id, 10)
              : "",
        },
      });
    }
    if (selectedCentreProduct.price.priceType === 1) {
      setFormData({
        ...formData,
        centreProduct: {
          required: true,
          value: parseInt(selectedCentreProduct.id, 10),
          error: "",
        },
        priceType: {
          ...formData.priceType,
          value: 4,
        },
        treatmentPrice: selectedCentreProduct.price.price,
        treatmentCurrency: {
          required: true,
          value: parseInt(selectedCentreProduct.price.currency.id, 10),
          error: "",
        },
        treatmentUnit: selectedCentreProduct.price.unit,
        tgap: selectedCentreProduct.price.tax,
        transportType: {
          ...formData.transportType,
          value:
            selectedCentreProduct.price.transportTypes?.length == 1
              ? parseInt(selectedCentreProduct.price.transportTypes[0].id, 10)
              : "",
        },
      });
    }
    if (selectedCentreProduct.price.priceType === 3) {
      setFormData({
        ...formData,
        centreProduct: {
          required: true,
          value: parseInt(selectedCentreProduct.id, 10),
          error: "",
        },
        priceType: {
          ...formData.priceType,
          value: 1,
        },
      });
    }
  };

  const onPriceTypeSelect = (e) => {
    if (formData.priceType.value === 4 && parseInt(e.target.value, 10) === 1) {
      setFormData({
        ...formData,
        priceType: {
          ...formData.priceType,
          value: parseInt(e.target.value, 10),
        },
      });
    } else {
      setFormData({
        ...formData,
        priceType: {
          ...formData.priceType,
          value: parseInt(e.target.value, 10),
        },
        treatmentPrice: solution ? formData.treatmentPrice : "",
        treatmentCurrency: {
          required: true,
          value: solution
            ? formData.treatmentCurrency.value
            : parseInt(countryId, 10),
          error: "",
        },
        treatmentUnit: solution ? formData.treatmentUnit : "",
        transportPrice: solution ? formData.transportPrice : "",
        transportCurrency: {
          required: true,
          value: solution
            ? formData.transportCurrency.value
            : parseInt(countryId, 10),
          error: "",
        },
        transportUnit: solution ? formData.transportUnit : "",
        tgap: solution ? formData.tgap : null,
        pollutionComment: {
          required: true,
          value: solution ? formData.pollutionComment.value : "",
          error: "",
        },
      });
    }
  };

  const onTreatmentPriceChange = (e) => {
    setFormData({
      ...formData,
      treatmentPrice:
        !e.target.value || /^-?\d*[.,]?\d{0,2}$/.test(e.target.value)
          ? e.target.value
          : formData.treatmentPrice,
    });
  };

  const onTransportPriceChange = (e) => {
    setFormData({
      ...formData,
      transportPrice:
        !e.target.value || /^-?\d*[.,]?\d{0,2}$/.test(e.target.value)
          ? e.target.value
          : formData.transportPrice,
    });
  };

  const onTreatmentCurrencySelect = (selectedCurrency) => {
    setFormData({
      ...formData,
      treatmentCurrency: {
        ...formData.treatmentCurrency,
        error: "",
        value: parseInt(selectedCurrency.value, 10),
      },
    });
  };

  const onTransportCurrencySelect = (selectedCurrency) => {
    setFormData({
      ...formData,
      transportCurrency: {
        ...formData.transportCurrency,
        error: "",
        value: parseInt(selectedCurrency.value, 10),
      },
    });
  };

  const onTreatmentUnitSelect = (selectedUnit) => {
    setFormData({
      ...formData,
      treatmentUnit: selectedUnit.value,
    });
  };

  const onTransportUnitSelect = (selectedUnit) => {
    setFormData({
      ...formData,
      transportUnit: selectedUnit.value,
    });
  };

  const onTGAPChange = (e) => {
    setFormData({
      ...formData,
      tgap: /^[0-9]*[.,]?\d{0,2}$/.test(e.target.value)
        ? e.target.value
        : formData.tgap,
    });
  };

  const onPriceBySelect = (transportPriceType) => {
    setFormData({
      ...formData,
      transportPriceType: {
        ...formData.transportPriceType,
        error: "",
        value: transportPriceType.value
          ? parseInt(transportPriceType.value, 10)
          : "",
      },
    });
  };

  const onTransportTypeSelect = (selectedTransport) => {
    setFormData({
      ...formData,
      transportType: {
        ...formData.transportType,
        error: "",
        value: selectedTransport.value
          ? parseInt(selectedTransport.value, 10)
          : "",
      },
    });
  };

  const onAllocationSelect = (allocation) => {
    setFormData({
      ...formData,
      allocation: {
        ...formData.allocation,
        error: "",
        value: allocation.value,
      },
    });
  };

  // While editing solution, adding transportPrice(using the add button)
  const selectTransportPrice = (selectedTransportPrice) => {
    const selectedPrice = solution.solutionTransportPrices.find(
      (priceItem) => priceItem.id === selectedTransportPrice.value
    );
    setFormData({
      ...formData,
      selectedTransportPriceId: {
        ...formData.selectedTransportPriceId,
        value: selectedTransportPrice.value,
      },
      transportPriceType: {
        ...formData.transportPriceType,
        error: "",
        value: selectedPrice
          ? parseInt(selectedPrice.transportPriceType.id, 10)
          : "",
      },
      transportType: {
        ...formData.transportType,
        error: "",
        value: selectedPrice
          ? parseInt(selectedPrice.transportType.id, 10)
          : "",
      },
      transportPrice: selectedPrice?.price ?? "",
      transportUnit: selectedPrice?.unit ?? "",
      transportCurrency: {
        ...formData.transportCurrency,
        error: "",
        value: selectedPrice
          ? parseInt(selectedPrice.currency.id, 10)
          : parseInt(countryId, 10),
      },
    });
  };

  const onCommentChange = (e) => {
    setFormData({
      ...formData,
      internalComment: e.target.value,
    });
  };

  const onQuoteCommentChange = (e) => {
    setFormData({
      ...formData,
      quoteComment: e.target.value,
    });
  };

  const onPollutionCommentChange = (e) => {
    setFormData({
      ...formData,
      pollutionComment: {
        ...formData.pollutionComment,
        error: "",
        value: e.target.value,
      },
    });
  };

  const onFilterApply = (supplierId, search = "") => {
    const productIds = formData.products.map((product) => product.value);
    const selectedSupplierIds = formData.suppliers.map(
      (supplier) => supplier.value
    );
    let subCategories = [parseInt(enquirySubCategoryId, 10)];
    const suppliersIds = supplierId ? [supplierId] : selectedSupplierIds;
    // for materials send all 3 subcategories related to materials
    if (
      parseInt(enquirySubCategoryId, 10) === 3 ||
      parseInt(enquirySubCategoryId, 10) === 4 ||
      parseInt(enquirySubCategoryId, 10) === 6
    ) {
      subCategories = [3, 4, 6];
    }
    setCentreProductsLoadingStatus(true);
    setCentreProductsAPIError("");
    setCentreLoading(true);
    axios
      .get(
        `/companies/centers?suppliers=${JSON.stringify(
          suppliersIds
        )}&products=${JSON.stringify(
          productIds
        )}&subCategories=${JSON.stringify(
          subCategories
        )}&countries=[${countryId}]&searchByCompany=${search}&limit=50&orderBy=asc&orderColumn=companyName`
      )
      .then((response) => {
        const centersData = response.data.centers.map((productItem) => {
          return { name: productItem.companyName, id: productItem.id };
        });
        setCentres(centersData);
        setCentreProducts(response.data.centers);
        setCentreProductsAPIError("");
        setCentreProductsLoadingStatus(false);
        setCentreLoading(false);
        if (!solution) {
          setSolutionEditDataLoad(false);
        }
      })
      .catch((error) => {
        setCentres([]);
        setCentreProducts([]);
        setCentreProductsLoadingStatus(false);
        setCentreProductsAPIError(
          error.response.data?.errors[0]?.message ?? "API Error"
        );
        if (!solution) {
          setSolutionEditDataLoad(false);
        }
      });
  };

  const getFormData = (data) => {
    const dataModified = {
      requestId: enquiryId,
      priceType: data.priceType.value,
      internalComment: data.internalComment,
      quoteComment: data.quoteComment,
      solutionType: {
        id: 5,
      },
      allocation: data.allocation.value,
    };

    switch (data.priceType.value) {
      case priceTypes.TransportTreatmentSeparated:
        dataModified.logisticFlow = data.logisticFlow;
        if (!data.transportPrice) {
          dataModified.solutionStatus = {
            id: 5, // PENDING_TRANSPORT_QUOTATION
          };
        }
        dataModified.pollutionComment = data.pollutionComment.value;
        dataModified.centre = {
          id: data.centre.value.id,
        };

        dataModified.centreProduct = {
          id: data.centreProduct.value,
        };
        dataModified.solutionTreatmentPrices = [
          {
            ...(solution?.solutionTreatmentPrices.length > 0 &&
              solution?.solutionTreatmentPrices[0].id && {
                id: solution.solutionTreatmentPrices[0].id,
              }),
            selectedPrice: true,
            price: data.treatmentPrice
              ? Number(String(data.treatmentPrice).replace(",", "."))
              : null,
            unit: data.treatmentUnit ? data.treatmentUnit : null,
            currency: {
              id: data.treatmentCurrency.value,
            },
            tgap: data.tgap,
            comment: data.pollutionComment.value,
          },
        ];
        dataModified.solutionTransportPrices = [
          {
            ...(data.selectedTransportPriceId.value &&
              !addTransportPriceSection && {
                id: data.selectedTransportPriceId.value,
              }),
            selectedPrice: true,
            price: data.transportPrice
              ? Number(String(data.transportPrice).replace(",", "."))
              : null,
            unit: data.transportUnit ? data.transportUnit : null,
            transportType: {
              id: data.transportType.value,
            },
            transportPriceType: {
              id: data.transportPriceType.value,
            },
            currency: {
              id: data.transportCurrency.value,
            },
            internalComment: data.internalComment,
            quoteComment: data.quoteComment,
          },
        ];
        break;
      case priceTypes.TransportTreatment:
        dataModified.logisticFlow = data.logisticFlow;
        dataModified.centre = {
          id: data.centre.value.id,
        };
        if (!data.treatmentPrice) {
          dataModified.solutionStatus = {
            id: 5, // PENDING_TRANSPORT_QUOTATION
          };
        }
        dataModified.centreProduct = {
          id: data.centreProduct.value,
        };
        dataModified.solutionTransportPrices = [
          {
            selectedPrice: true,
            transportType: {
              id: data.transportType.value,
            },
            price: data.transportPrice
              ? Number(String(data.transportPrice).replace(",", "."))
              : null,
            unit: data.transportUnit ? data.transportUnit : null,
            currency: {
              id: data.transportCurrency.value,
            },
            internalComment: data.pollutionComment.value,
          },
        ];
        dataModified.solutionTreatmentPrices = [];
        break;
      case priceTypes.TransportOnly:
        dataModified.haulier = {
          id: data.haulier.value.value,
        };
        if (!data.transportPrice) {
          dataModified.solutionStatus = {
            id: 5, // PENDING_TRANSPORT_QUOTATION
          };
        }
        dataModified.solutionTransportPrices = [
          {
            selectedPrice: true,
            price: data.transportPrice
              ? Number(String(data.transportPrice).replace(",", "."))
              : null,
            unit: data.transportUnit ? data.transportUnit : null,
            transportType: {
              id: data.transportType.value,
            },
            transportPriceType: {
              id: data.transportPriceType.value,
            },
            currency: {
              id: data.transportCurrency.value,
            },

            internalComment: data.internalComment,
            quoteComment: data.quoteComment,
          },
        ];
        break;
      case priceTypes.TreatmentOnly:
        dataModified.logisticFlow = data.logisticFlow;
        dataModified.pollutionComment = data.pollutionComment.value;
        dataModified.centre = {
          id: data.centre.value.id,
        };
        dataModified.centreProduct = {
          id: data.centreProduct.value,
        };
        dataModified.solutionTreatmentPrices = [
          {
            ...(solution?.solutionTreatmentPrices.length > 0 &&
              solution?.solutionTreatmentPrices[0].id && {
                id: solution.solutionTreatmentPrices[0].id,
              }),
            selectedPrice: true,
            price: data.treatmentPrice
              ? Number(String(data.treatmentPrice).replace(",", "."))
              : null,
            unit: data.treatmentUnit ? data.treatmentUnit : null,
            currency: {
              id: data.treatmentCurrency.value,
            },
            tgap: data.tgap,
          },
        ];
        break;
      default:
    }
    return dataModified;
  };

  const validateForm = (data) => {
    let isFormValid = true;
    if (data.priceType.value !== priceTypes.TransportOnly) {
      if (!data.centre.value) {
        isFormValid = false;
        data.centre.error = t("CENTER_REQUIRED");
      }
      if (!data.centreProduct.value) {
        isFormValid = false;
        data.centreProduct.error = t("CENTER_PRODUCT_REQUIRED");
      }
    }
    if (data.priceType.value === priceTypes.TransportTreatmentSeparated) {
      if (!data.treatmentCurrency.value) {
        isFormValid = false;
        data.treatmentCurrency.error = t("REQUIRED");
      }

      if (!data.transportCurrency.value) {
        isFormValid = false;
        data.transportCurrency.error = t("REQUIRED");
      }

      if (
        !data.pollutionComment.value &&
        parseInt(enquirySubCategoryId, 10) === POLLUTED_SOILS &&
        countryId === country.France
      ) {
        isFormValid = false;
        data.pollutionComment.error = t("CONCERNED_POLLUTION_REQUIRED_FIELD");
      }
      if (!data.transportType.value) {
        isFormValid = false;
        data.transportType.error = t("ADMIN_SOLUTION_TRANSPORT_TYPE_REQUIRED");
      }
      if (!data.transportPriceType.value) {
        isFormValid = false;
        data.transportPriceType.error = t("ADMIN_SOLUTION_PRICE_BY_REQUIRED");
      }
    }
    if (data.priceType.value === priceTypes.TransportTreatment) {
      if (!data.transportCurrency.value) {
        isFormValid = false;
        data.transportCurrency.error = t("REQUIRED");
      }

      if (!data.transportType.value) {
        isFormValid = false;
        data.transportType.error = t("ADMIN_SOLUTION_TRANSPORT_TYPE_REQUIRED");
      }

      if (
        !data.pollutionComment.value &&
        parseInt(enquirySubCategoryId, 10) === POLLUTED_SOILS &&
        countryId === country.France
      ) {
        isFormValid = false;
        data.pollutionComment.error = t("CONCERNED_POLLUTION_REQUIRED_FIELD");
      }
    }
    if (
      data.priceType.value === priceTypes.TransportOnly ||
      parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY
    ) {
      if (!data.haulier.value) {
        isFormValid = false;
        data.haulier.error = t("HAULIER_REQUIRED");
        data.priceType.value = 3;
      }
      if (!data.transportCurrency.value) {
        isFormValid = false;
        data.transportCurrency.error = t("REQUIRED");
      }

      if (!data.transportPriceType.value) {
        isFormValid = false;
        data.transportPriceType.error = t("ADMIN_SOLUTION_PRICE_BY_REQUIRED");
      }
      if (!data.transportType.value) {
        isFormValid = false;
        data.transportType.error = t("ADMIN_SOLUTION_TRANSPORT_TYPE_REQUIRED");
      }
    }
    if (data.priceType.value === priceTypes.TreatmentOnly) {
      if (!data.treatmentCurrency.value) {
        isFormValid = false;
        data.treatmentCurrency.error = t("REQUIRED");
      }

      if (
        !data.pollutionComment.value &&
        parseInt(enquirySubCategoryId, 10) === POLLUTED_SOILS &&
        countryId === country.France
      ) {
        isFormValid = false;
        data.pollutionComment.error = t("CONCERNED_POLLUTION_REQUIRED_FIELD");
      }
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }

    return isFormValid;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData);
    if (isFormValid) {
      const data = getFormData(formData);
      setDataSaveStatus(true);
      setCreateSolutionAPIError("");
      // Create solution
      if (!isSolutionEdit) {
        axios
          .post(`/solutions`, data)
          .then(() => {
            setDataSaveStatus(false);
            onClose();
            onSolutionCreation();
          })
          .catch((error) => {
            setDataSaveStatus(false);
            setCreateSolutionAPIError(error.response?.data?.message ?? "");
          });
      }
      // Edit solution
      if (isSolutionEdit) {
        axios
          .put(`/solutions/${solution.id}`, data)
          .then(() => {
            setDataSaveStatus(false);
            onClose();
          })
          .catch((error) => {
            setDataSaveStatus(false);
            setCreateSolutionAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  const showPollutionParamsDetails = () => {
    setPollutionParamsVisibility(!isPollutionParamsVisible);
  };

  const onAddTransportPrice = () => {
    setTransportPriceSectionVisibility(!addTransportPriceSection);
  };

  const getPollutionComment = (
    priceTypeId,
    selectedSolution,
    selectedTransportPrice
  ) => {
    if (priceTypeId === 1 || priceTypeId === 4) {
      return selectedSolution.pollutionComment;
    }
    if (priceTypeId === 2 || priceTypeId === 3) {
      return selectedTransportPrice
        ? selectedTransportPrice.internalComment
        : "";
    }
    return "";
  };

  const getSelectedTransportPrice = () => {
    if (
      solution.solutionTransportPrices &&
      solution.solutionTransportPrices.length > 0
    ) {
      const selectedPrice = solution.solutionTransportPrices.filter(
        (priceItem) => priceItem.selectedPrice === true
      );
      if (selectedPrice && selectedPrice.length > 0) {
        return selectedPrice[0];
      }
    }
    return null;
  };

  useEffect(() => {
    if (
      !isSolutionEdit ||
      parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY
    ) {
      onFilterApply();
    }
    if (parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY) {
      setFormData({
        ...formData,
        priceType: {
          ...formData.priceType,
          value: 3,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !isSolutionEdit &&
      parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY
    ) {
      setSuppliersLoadingStatus(true);
      setProductsAPIError("");
      axios
        .get(
          `/companies/suppliers?requestId=${enquiryId}&countries=[${countryId}]&status=1&limit=-1&orderBy=asc&orderColumn=supplierName`
        )
        .then((response) => {
          const carriersData = response.data.suppliers.map((supplierItem) => {
            return { label: supplierItem.name, value: supplierItem.id };
          });
          setSuppliers(carriersData);
          setSuppliersLoadingStatus(false);
          if (!isSolutionEdit) {
            setSolutionEditDataLoad(false);
          }
        })
        .catch((error) => {
          setSuppliers([]);
          setSuppliersLoadingStatus(false);
          setProductsAPIError(error.response?.data?.message ?? "");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      !isSolutionEdit &&
      parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY
    ) {
      setHaulierLoadingStatus(true);
      setHaulierAPIError("");
      axios
        .get(`/companies/hauliers?countries=[${countryId}]&status=1&limit=-1`)
        .then((response) => {
          const hauliersData = response.data.hauliers.map((haulierItem) => {
            return { label: haulierItem.companyName, value: haulierItem.id };
          });
          setHauliers(hauliersData);
          setHaulierLoadingStatus(false);
          if (!isSolutionEdit) {
            setSolutionEditDataLoad(false);
          }
        })
        .catch((error) => {
          setHauliers([]);
          setHaulierLoadingStatus(false);
          setHaulierAPIError(error.response?.data?.message ?? "");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let url = `/transports?countries=[${countryId}]&priceType=${formData.priceType.value}&status=1&limit=-1&orderBy=asc&orderColumn=orderIndex`;
    if (parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY) {
      url = `/transports?countries=[${countryId}]&priceType=${formData.priceType.value}&status=1&subCategoryId=${enquirySubCategoryId}&limit=-1&orderBy=asc&orderColumn=orderIndex`;
    }
    setTransportTypesLoadingStatus(true);
    setTransportTypesAPIError("");
    axios
      .get(url)
      .then((response) => {
        const transportTypesLocal = response.data.transports.map(
          (transportTypeItem) => {
            return {
              label: transportTypeItem.name,
              value: transportTypeItem.id,
            };
          }
        );
        setTransportTypes(transportTypesLocal);
        setTransportTypesLoadingStatus(false);
        if (!isSolutionEdit) {
          setSolutionEditDataLoad(false);
        }
      })
      .catch((error) => {
        setTransportTypes([]);
        setTransportTypesLoadingStatus(false);
        setTransportTypesAPIError(error.response?.data?.message ?? "");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isSolutionEdit) {
      setProductsLoadingStatus(true);
      setSuppliersAPIError("");
      axios
        .get(
          `/products?subCategories=[${enquirySubCategoryId}]&countries=[${countryId}]&limit=-1&orderBy=asc&orderColumn=name&status=1&listType=subList`
        )
        .then((response) => {
          const productsData = response.data.products.map((productItem) => {
            return { label: productItem.name, value: productItem.id };
          });
          setProducts(productsData);
          setSuppliersAPIError("");
          setProductsLoadingStatus(false);
          if (!isSolutionEdit) {
            setSolutionEditDataLoad(false);
          }
        })
        .catch((error) => {
          setProducts([]);
          setProductsLoadingStatus(false);
          setSuppliersAPIError(error.response.data?.errors[0]?.message ?? "");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      formData.centreProduct?.value?.value &&
      parseInt(enquirySubCategoryId, 10) === POLLUTED_SOILS
    ) {
      setPollutionParamsLoadingStatus(true);
      axios
        .get(
          `/solutions/pollution/check?requestId=${enquiryId}&centerProductId=${formData.centreProduct.value.value}`
        )
        .then((response) => {
          setPollutionParamsLoadingStatus(false);
          setPollutionParams(response.data.errors);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.centreProduct.value]);

  useEffect(() => {
    const currenciesList = Object.entries(userCurrency).map((entry) => {
      return { label: entry[1], value: entry[0] };
    });
    setCurrencies(currenciesList);
  }, [generalParams]);

  useEffect(() => {
    if (countryId) {
      // by default select currency of the country with which user logged in
      setFormData({
        ...formData,
        treatmentCurrency: {
          ...formData.treatmentCurrency,
          error: "",
          value: parseInt(countryId, 10),
        },
        transportCurrency: {
          ...formData.transportCurrency,
          error: "",
          value: parseInt(countryId, 10),
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryId]);

  useEffect(() => {
    setSolutionEditDataLoad(true);
    if (isSolutionEdit) {
      const transportPriceSelected = cloneDeep(getSelectedTransportPrice());
      setSolutionEditDataLoad(false);

      setFormData({
        ...formData,
        priceType: {
          ...formData.priceType,
          value: parseInt(solution.priceType, 10),
        },
        logisticFlow: solution.logisticFlow,
        treatmentPrice: solution.solutionTreatmentPrices[0]?.price ?? "",
        treatmentCurrency: {
          required: true,
          value:
            solution.solutionTreatmentPrices[0]?.currency?.id ??
            parseInt(countryId, 10),
          error: "",
        },
        treatmentUnit: solution.solutionTreatmentPrices[0]?.unit ?? "",
        transportPrice: transportPriceSelected?.price ?? "",
        transportCurrency: {
          required: true,
          value:
            transportPriceSelected?.currency?.id ?? parseInt(countryId, 10),
          error: "",
        },
        transportUnit: transportPriceSelected?.unit ?? "",
        tgap: solution.solutionTreatmentPrices[0]?.tgap ?? "",
        pollutionComment: {
          required: true,
          value: getPollutionComment(
            parseInt(solution.priceType, 10),
            solution,
            transportPriceSelected
          ),
          error: "",
        },
        internalComment: solution.internalComment ?? "",
        quoteComment: solution.quoteComment ?? "",
        haulier: {
          ...formData.haulier,
          value: {
            value: solution.haulier?.id ?? "",
            label: solution.haulier?.companyName,
          },
        },
        centre: {
          ...formData.centre,
          value: {
            id: solution.centre?.id ?? "",
            name: solution.centre?.companyName,
          },
        },
        centreProduct: {
          ...formData.centreProduct,
          value: {
            value: solution.centreProduct?.id ?? "",
            label: solution.centreProduct?.product?.name,
          },
        },
        transportPriceType: {
          ...formData.transportPriceType,
          value: transportPriceSelected?.transportPriceType?.id ?? "",
        },
        transportType: {
          ...formData.transportType,
          value: transportPriceSelected?.transportType?.id ?? "",
        },
        selectedTransportPriceId: {
          ...formData.selectedTransportPriceId,
          value: transportPriceSelected?.id ?? "",
        },
      });
      if (parseInt(solution.priceType, 10) !== 3) {
        onFilterApply(solution.centre?.supplierId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSolutionEdit]);

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          {isSolutionEdit && (
            <Title>{`${title}, ${solution.centre?.companyName ?? ""}`}</Title>
          )}
          {!isSolutionEdit && <Title>{title}</Title>}
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close selling price popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          {!isSolutionEdit && (
            <FiltersContainer>
              <FiltersTitle>{t("FILTER_MANUAL_MATCHING")}</FiltersTitle>
              <FiltersWrapper>
                <FilterOption>
                  <FiltersLabel>{t("SUB_CATEGORY")}</FiltersLabel>
                  <SubCategoryName>{t(enquirySubCategoryName)}</SubCategoryName>
                </FilterOption>
                <>
                  {parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <FilterOption>
                      {productsAPIError !== "" && (
                        <APIErrorMEssage>{productsAPIError}</APIErrorMEssage>
                      )}
                      {isProductLoading && (
                        <LoadingContainer>
                          <PulseLoader color="#004c7f" />
                        </LoadingContainer>
                      )}
                      {!isProductLoading && productsAPIError === "" && (
                        <DropdownWithSearch
                          placeholder={t("SELECT")}
                          label={t("PRODUCT")}
                          value={formData.products}
                          options={products}
                          onChange={onProductSelect}
                        />
                      )}
                    </FilterOption>
                  )}
                  {parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <FilterOption>
                      {suppliersAPIError !== "" && (
                        <APIErrorMEssage>{suppliersAPIError}</APIErrorMEssage>
                      )}
                      {isSuppliersLoading && (
                        <LoadingContainer>
                          <PulseLoader color="#004c7f" />
                        </LoadingContainer>
                      )}
                      {!isSuppliersLoading && suppliersAPIError === "" && (
                        <DropdownWithSearch
                          placeholder="Search"
                          label={t("SUPPLIER")}
                          value={formData.suppliers}
                          options={suppliers}
                          onChange={onSupplierSelect}
                        />
                      )}
                    </FilterOption>
                  )}
                </>
              </FiltersWrapper>

              {!isSolutionEdit &&
                parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                  <FiltersBtnWrapper>
                    <Button
                      styles={{
                        color: "white",
                        background: "#1BACE4",
                        border: "1px solid #1BACE4",
                        "&:hover": {
                          backgroundColor: "#1589b6",
                        },
                      }}
                      id="apply-filter"
                      disabled={
                        isSuppliersLoading ||
                        isProductLoading ||
                        suppliersAPIError !== "" ||
                        productsAPIError !== ""
                      }
                      onClick={() => onFilterApply()}
                    >
                      <>
                        {!isCentreProductsLoading && t("APPLY_FILTER")}
                        {isCentreProductsLoading && (
                          <ClipLoader size={15} color="#fff" />
                        )}
                      </>
                    </Button>
                  </FiltersBtnWrapper>
                )}
            </FiltersContainer>
          )}
          {isSolutionEditDataLoading && (
            <SolutionEditLoader>
              <PulseLoader color="#004c7f" />
            </SolutionEditLoader>
          )}
          {!isSolutionEditDataLoading && (
            <OptionsWrapper>
              <CentreProductsContainer>
                {parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY &&
                  hauliersAPIError !== "" && (
                    <APIErrorMEssage>{hauliersAPIError}</APIErrorMEssage>
                  )}
                {parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY &&
                  isHauliersLoading && (
                    <LoadingContainer>
                      <PulseLoader color="#004c7f" />
                    </LoadingContainer>
                  )}
                {!isHauliersLoading &&
                  hauliersAPIError === "" &&
                  parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY && (
                    <DropdownWithSearch
                      placeholder={t("SELECT_CARRIER")}
                      label={t("CARRIER")}
                      value={formData.haulier.value}
                      options={hauliers}
                      required
                      error={formData.haulier.error}
                      isMulti={false}
                      disabled={!!isSolutionEdit}
                      onChange={onHaulierSelect}
                    />
                  )}
                {centreProductsAPIError === "" &&
                  parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <>
                      {/* <DropdownWithSearch
                        placeholder={t("SELECT_CENTRE")}
                        label={t("CENTER")}
                        value={formData.centre.value}
                        options={centres}
                        required
                        isMulti={false}
                        disabled={!!isSolutionEdit}
                        error={formData.centre.error}
                        onChange={onCentresSelect}
                        onKeyUp={searchEntity}
                      /> */}
                      <div>
                        <CenterList
                          formData={formData}
                          setFormData={setFormData}
                          isEditMode={isSolutionEdit}
                          centreList={centres}
                          onFilterApply={onFilterApply}
                          onCentresSelect={onCentresSelect}
                          centreLoading={centreLoading}
                        />
                      </div>
                      <div>
                        {!isSolutionEdit && (
                          <DropdownProduct
                            placeholder={t("SELECT_PRODUCT")}
                            name="solution-product-dropdown"
                            label={t("PRODUCT")}
                            value={formData.centreProduct.value}
                            options={centreProductsList}
                            defaultOption=""
                            required
                            isMulti={false}
                            error={formData.centreProduct.error}
                            disabled={
                              !formData.centre.value || !!isSolutionEdit
                            }
                            onChange={onCentreProductSelect}
                          />
                        )}
                        {isSolutionEdit && (
                          <DropdownWithSearch
                            placeholder={t("SELECT_PRODUCT")}
                            label={t("PRODUCT")}
                            value={formData.centreProduct.value}
                            options={centreProductsList}
                            required
                            isMulti={false}
                            error={formData.centreProduct.error}
                            disabled={
                              !formData.centre.value || !!isSolutionEdit
                            }
                            onChange={onCentreProductSelect}
                          />
                        )}
                        <PollutionParameterMessage
                          centreProduct={
                            formData.centreProduct?.value?.value ?? ""
                          }
                          isLoading={isPollutionParamsLoading}
                          isPollutionParamsAvailable={
                            pollutionParams.length > 0
                          }
                          subCategoryId={parseInt(enquirySubCategoryId, 10)}
                          showPollutionParamsDetails={
                            showPollutionParamsDetails
                          }
                        />
                      </div>
                    </>
                  )}
              </CentreProductsContainer>
              {isPollutionParamsVisible && (
                <PollutionParameterTable data={pollutionParams} />
              )}
              <div>
                {parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                  <RadioButton
                    value={formData.priceType.value}
                    onChange={onPriceTypeSelect}
                    name="price-type"
                    options={[
                      {
                        label: t("TREATMENT_AND_TRANSPORT_PRICE_SEPARATE"),
                        value: 1,
                      },
                      { label: t("TREATMENT_AND_TRANSPORT"), value: 2 },
                      { label: t("TREATMENT_ONLY"), value: 4 },
                    ]}
                  />
                )}
                {parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY && (
                  <RadioButton
                    value={3}
                    onChange={onPriceTypeSelect}
                    name="price-type"
                    options={[{ label: t("TRANSPORT_ONLY"), value: 3 }]}
                  />
                )}
              </div>
              <FlexRow>
                <Dropdown
                  label={t("SOLUTION_ALLOCATION")}
                  id="solution-allocation"
                  name="allocation"
                  value={formData.allocation.value}
                  defaultOption="0"
                  containerStyles={{ marginBottom: "1.32rem" }}
                  inputStyles={{ border: "1px solid #474747" }}
                  options={getValorisationRateOptions}
                  error={formData.allocation.error}
                  onChange={onAllocationSelect}
                />
              </FlexRow>
              <FlexRow>
                {formData.priceType.value ===
                  priceTypes.TransportTreatmentSeparated &&
                  parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <TransportTreatmentSeparated
                      data={formData}
                      solution={solution}
                      countryId={countryId}
                      currencies={currencies}
                      addTransportPriceSection={addTransportPriceSection}
                      transportTypesAPIError={transportTypesAPIError}
                      isTransportTypesLoading={isTransportTypesLoading}
                      transportTypes={transportTypes}
                      onTreatmentPriceChange={onTreatmentPriceChange}
                      onTreatmentCurrencySelect={onTreatmentCurrencySelect}
                      onTreatmentUnitSelect={onTreatmentUnitSelect}
                      onTGAPChange={onTGAPChange}
                      onPollutionCommentChange={onPollutionCommentChange}
                      selectTransportPrice={selectTransportPrice}
                      onAddTransportPrice={onAddTransportPrice}
                      onPriceBySelect={onPriceBySelect}
                      onTransportTypeSelect={onTransportTypeSelect}
                      onTransportUnitSelect={onTransportUnitSelect}
                      onTransportPriceChange={onTransportPriceChange}
                      onTransportCurrencySelect={onTransportCurrencySelect}
                      unitList={unitList}
                      enquirySubCategoryId={enquirySubCategoryId}
                    />
                  )}
                {formData.priceType.value === priceTypes.TransportTreatment &&
                  parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <TransportTreatment
                      data={formData}
                      countryId={countryId}
                      currencies={currencies}
                      transportTypesAPIError={transportTypesAPIError}
                      isTransportTypesLoading={isTransportTypesLoading}
                      transportTypes={transportTypes}
                      onTransportTypeSelect={onTransportTypeSelect}
                      onTransportUnitSelect={onTransportUnitSelect}
                      onTransportPriceChange={onTransportPriceChange}
                      onPollutionCommentChange={onPollutionCommentChange}
                      onTransportCurrencySelect={onTransportCurrencySelect}
                      unitList={unitList}
                      enquirySubCategoryId={enquirySubCategoryId}
                    />
                  )}
                {parseInt(enquirySubCategoryId, 10) === TRANSPORT_ONLY && (
                  <TransportOnly
                    data={formData}
                    currencies={currencies}
                    transportTypes={transportTypes}
                    transportTypesAPIError={transportTypesAPIError}
                    isTransportTypesLoading={isTransportTypesLoading}
                    onPriceBySelect={onPriceBySelect}
                    onTransportTypeSelect={onTransportTypeSelect}
                    onTransportUnitSelect={onTransportUnitSelect}
                    onTransportPriceChange={onTransportPriceChange}
                    onTransportCurrencySelect={onTransportCurrencySelect}
                    unitList={unitList}
                    enquirySubCategoryId={enquirySubCategoryId}
                  />
                )}
                {formData.priceType.value === priceTypes.TreatmentOnly &&
                  parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                    <TreatmentOnly
                      data={formData}
                      currencies={currencies}
                      countryId={countryId}
                      onTreatmentPriceChange={onTreatmentPriceChange}
                      onTreatmentCurrencySelect={onTreatmentCurrencySelect}
                      onTreatmentUnitSelect={onTreatmentUnitSelect}
                      onTGAPChange={onTGAPChange}
                      onPollutionCommentChange={onPollutionCommentChange}
                      unitList={unitList}
                    />
                  )}
              </FlexRow>
              <CommentsContainer>
                <TextInput
                  type="textarea"
                  label={t(
                    "MANUAL_MATCHING_CREATION_POP_UP_PURCHASE_PRICE_ASUMPTION"
                  )}
                  id="comment"
                  name="comment"
                  value={formData.internalComment}
                  onChange={onCommentChange}
                  inputStyles={{ height: "4rem" }}
                />
                <TextInput
                  type="textarea"
                  label={t(
                    "MATCHING_EDITION_POP_UP_SPECIFIC_CONDITIONS_CLIENT"
                  )}
                  id="quote-comment"
                  name="quote-comment"
                  value={formData.quoteComment}
                  onChange={onQuoteCommentChange}
                  inputStyles={{ height: "4rem" }}
                />
              </CommentsContainer>
              {isSolutionEdit &&
                formData.priceType.value !== priceTypes.TransportOnly &&
                parseInt(enquirySubCategoryId, 10) !== TRANSPORT_ONLY && (
                  <>
                    <div>
                      <EditOptionsLabel>
                        {t("MATCHING_EDITION_POP_UP_MIN_BILLING")}
                      </EditOptionsLabel>
                      <EditOptionsDescription>
                        {solution.centreProduct?.minBilling ?? ""}
                      </EditOptionsDescription>
                    </div>

                    <div>
                      <EditOptionsLabel>
                        {t("MATCHING_EDITION_POP_UP_PRICE_DETAILS")}
                      </EditOptionsLabel>
                      {solution.centreProduct?.internalComment && (
                        <EditOptionsPreDefinedDescription>
                          {solution.centreProduct.internalComment}
                        </EditOptionsPreDefinedDescription>
                      )}
                    </div>

                    <div>
                      <EditOptionsLabel>
                        {t("MATCHING_EDITION_POP_UP_ACCEPTANCE_REQUIREMENTS")}
                      </EditOptionsLabel>
                      <EditOptionsDescription>
                        {solution.centreProduct?.acceptanceRequirements ?? ""}
                      </EditOptionsDescription>
                      <EditOptionsDescription>
                        {solution.centreProduct?.acceptanceSpecificities ?? ""}
                      </EditOptionsDescription>
                    </div>
                    <div>
                      <EditOptionsLabel>
                        {t("MATCHING_EDITION_POP_UP_ALERT")}
                      </EditOptionsLabel>
                      {solution.centreProduct?.comment && (
                        <EditOptionsPreDefinedDescription>
                          {solution.centreProduct.comment}
                        </EditOptionsPreDefinedDescription>
                      )}
                    </div>
                  </>
                )}
            </OptionsWrapper>
          )}
        </FormBody>
        <ButtonWrapper>
          {createSolutionAPIError && <div>{createSolutionAPIError}</div>}
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            disabled={isSolutionEditDataLoading}
            onClick={onSubmit}
          >
            <>
              {isSolutionCreating && <ClipLoader size={15} color="#fff" />}
              {!isSolutionCreating && t("SUBMIT")}
            </>
          </Button>
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditSolution.propTypes = {
  id: PropTypes.number,
  solution: PropTypes.shape({
    id: PropTypes.number,
    logisticFlow: PropTypes.number,
    priceType: PropTypes.number,
    solutionTreatmentPrices: PropTypes.arrayOf(PropTypes.object),
    solutionTransportPrices: PropTypes.arrayOf(PropTypes.object),
    centre: PropTypes.shape({
      id: PropTypes.number,
      companyName: PropTypes.string,
    }),
    haulier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    centreProduct: PropTypes.shape({
      id: PropTypes.number,
      product: PropTypes.shape({ name: PropTypes.string }),
      acceptanceRequirements: PropTypes.string,
      acceptanceSpecificities: PropTypes.string,
      comment: PropTypes.string,
      internalComment: PropTypes.string,
      minBilling: PropTypes.string,
    }),
    pollutionComment: PropTypes.string,
    internalComment: PropTypes.string,
    quoteComment: PropTypes.string,
  }),
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onSolutionCreation: PropTypes.func,
  enquiryService: PropTypes.string,
  enquirySubCategoryName: PropTypes.string,
  enquirySubCategoryId: PropTypes.number,
  enquiryId: PropTypes.number,
};

AddEditSolution.defaultProps = {
  id: null,
  solution: null,
  onSolutionCreation: null,
  enquiryService: null,
  enquirySubCategoryName: null,
  enquirySubCategoryId: null,
  enquiryId: null,
};

export default withTranslation()(AddEditSolution);
